import { render, staticRenderFns } from "./modalEditUser.vue?vue&type=template&id=48881b8a&"
import script from "./modalEditUser.vue?vue&type=script&lang=js&"
export * from "./modalEditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports